import { Box, Grid, Stack } from "@mui/material";
import React from "react";
import { useNavigate, NavLink } from "react-router-dom";
import { SwiperSlide } from "swiper/react";
import diffrent2 from "../../assets/assesments/svg/assesment-3.svg";
import Type6 from "../../assets/common/svg/shape-3.svg";
import { ReactComponent as Type5 } from "../../assets/quickView/svg/box-1-img-6.svg";
import Ushape from "../../assets/quickView/svg/u-shape.svg";
import { vasanaTypeResultContainer } from "../../container/vasanaTypeResult.container";
import { bgImages } from "../../description/assessment.description";
import { changeSaReGaMaStyle } from "../../shared/CustomFunc";
import SEO from "../../shared/SEO";
import CircularProgressWithLabel from "../../shared/VSNCircularProgressWithLabel";
import VSNImage from "../../shared/VSNImage";
import VSNLoader from "../../shared/VSNLoader";
import VSNPaper from "../../shared/VSNPaper";
import { VSNSwiper } from "../../shared/VSNSwiper";
import VSNTypography from "../../shared/VSNTypography";
import compositionIcon from "../../assets/quickView/png/compositionIcon.png";
import { VasanaTypeResultStyle } from "./VasanaTypeResultStyle";
import VSNBreadcrumbs from "../../shared/VSNBreadcrumbs";
import onePagerResultContainer from "../../container/onePager.container";

const VasanaOnePagerResult = ({
  showBreadCrumbs,
  breadCrumbAndButton,
  endPointToCall,
  viewAllResult,
  from,
}) => {
  // const { onePagerAssessmentResult, loader, currentAssessment } =
  //   onePagerResultContainer({ endPointToCall });

  const {
    onePagerAssessmentResult: containerResult,
    loader,
    currentAssessment,
  } = from === "viewAll" ? {} : onePagerResultContainer({ endPointToCall });

  const onePagerAssessmentResult =
    from === "viewAll" ? viewAllResult : containerResult;

  const classes = VasanaTypeResultStyle();
  const vasanaTypeComposition =
    "Your Vāsanā Type is a unique behavioral profile made up of four types, Sa, Re, Ga, and Ma, with one as your dominant type.";

  const getClass = {
    1: classes.stickOne,
    2: classes.stickTwo,
    3: classes.stickThree,
    4: classes.stickFour,
  };

  const splitArray = (str) => {
    const data = str?.map((obj) =>
      obj?.includes(" ") ? splitArray(obj?.split(" ")) : obj
    );
    return data;
  };

  const breadcrumbsRoutes = [
    {
      path: "/assessments",
      label: "Assessments",
    },
    {
      path: "/assessments/1",
      label: `Vasana Type Dashboard`,
    },
  ];

  const scoreMapping = [
    {
      key: "sa",
      scoreKey: "sa_score",
      tends_to: "Independent, Strong-willed, Focused, and Purposeful.",
      color: "#8B3F9E",
    },
    {
      key: "re",
      scoreKey: "re_score",
      tends_to: "Energetic, Spontaneous, Friendly, and Adaptable",
      color: "#97C8E9",
    },
    {
      key: "ga",
      scoreKey: "ga_score",
      tends_to: "Responsible, Amenable, Supportive, and Inclusive",
      color: "#FFB142",
    },
    {
      key: "ma",
      scoreKey: "ma_score",
      tends_to: "Methodical, Perfectionist, Systematic, and Exacting",
      color: "#2D8F4E",
    },
  ];

  const baseImageUrl =
    "https://vasana-static.s3.us-east-1.amazonaws.com/images/vasana/";

  const transformedArray = scoreMapping.map(
    ({ key, scoreKey, color, tends_to }) => ({
      key,
      value: onePagerAssessmentResult?.[scoreKey] ?? 0,
      [scoreKey]: onePagerAssessmentResult?.[scoreKey] ?? 0,
      image: `${baseImageUrl}${key}/${key}-large.svg`,
      color,
      tends_to,
    })
  );

  if (
    from !== "viewAll" &&
    (loader?.assessmentResult || !onePagerAssessmentResult)
  ) {
    return <VSNLoader variant="fullPage" />;
  }

  return (
    <div className={classes.mainLayout}>
      <SEO contentKey="landing" />

      {from !== "viewAll" ? (
        !showBreadCrumbs ? (
          <Box mt={-1.8} mb={1.8}>
            <VSNBreadcrumbs {...{ breadcrumbsRoutes }} />
          </Box>
        ) : (
          <Box mb={1.8} className={classes.headingButton}>
            <Box>{breadCrumbAndButton}</Box>
          </Box>
        )
      ) : null}

      <Grid container spacing={3}>
        <Grid item md={7} lg={7} xs={12}>
          <Box mb={{ xs: 3, md: 4 }}>
            <VSNPaper className={classes.firstBox}>
              {bgImages?.map(
                (data, i) =>
                  !data?.notShow && (
                    <span
                      key={i}
                      className={`${classes.shape} ${
                        classes?.[data?.className]
                      }`}
                    >
                      {data.image}
                    </span>
                  )
              )}
              <Stack
                direction="row"
                justifyContent="space-between"
                className={classes.vasanatype}
                alignItems="center"
              >
                <VSNTypography variant="h4" component="h4">
                  Your Vasana Type is{" "}
                  <Box className={classes.vasanaTypeImage}>
                    <VSNImage
                      src={onePagerAssessmentResult?.large_icon}
                      alt="large_icon"
                    />
                  </Box>
                </VSNTypography>{" "}
              </Stack>
              <Box>
                <VSNTypography variant="h6" component="h6">
                  {onePagerAssessmentResult?.tends_to_str
                    ?.split(" ")
                    ?.map((val, i) => (
                      <VSNTypography
                        key={i}
                        variant="span"
                        component="span"
                        className={
                          splitArray(onePagerAssessmentResult?.tends_to)
                            ?.flat()
                            ?.includes(val?.replace(",", "").replace(".", ""))
                            ? classes.marketTends
                            : ""
                        }
                      >
                        {" "}
                        {val}
                      </VSNTypography>
                    ))}
                </VSNTypography>{" "}
                <VSNTypography
                  variant="body1"
                  component="p"
                  className={classes.marketInfo}
                >
                  <span
                    dangerouslySetInnerHTML={{
                      __html: changeSaReGaMaStyle(
                        onePagerAssessmentResult?.vasana_info?.summery
                      )?.replace(
                        onePagerAssessmentResult?.vasana_role?.secondary,
                        `<span style="color:#86650A;font-weight:700">${onePagerAssessmentResult?.vasana_role?.secondary}</span>`
                      ),
                    }}
                  />
                </VSNTypography>{" "}
              </Box>
              <Box className={classes.vasanaTypeAccordian}>
                <Type5 className={classes.flowerBgImg} />
                <VSNTypography
                  variant="body1"
                  component="p"
                  className={classes.marketInfo}
                >
                  {onePagerAssessmentResult?.vasana_info?.description}
                </VSNTypography>{" "}
              </Box>
            </VSNPaper>
          </Box>
        </Grid>
        <Grid item md={5} lg={5} xs={12} className={classes.quickViewContent2}>
          <Stack>
            <Box mb={3.5}>
              <VSNPaper className={classes.combinationMain}>
                <Stack direction="row" className={classes.combinationHeading}>
                  <VSNImage
                    src={compositionIcon}
                    alt="compositionIcon"
                    height={40}
                    width="auto"
                  />
                  <Box>
                    <VSNTypography
                      variant="h5"
                      component="h5"
                      className={classes.lgHeading}
                      mb={1}
                    >
                      Your Vasana Type Composition
                    </VSNTypography>
                    <VSNTypography variant="body1" component="p">
                      <span
                        dangerouslySetInnerHTML={{
                          __html: changeSaReGaMaStyle(vasanaTypeComposition),
                        }}
                      />
                    </VSNTypography>
                  </Box>
                </Stack>
                <Box>
                  {transformedArray?.map((ele, i) => (
                    <Stack
                      direction="row"
                      alignItems="center"
                      className={`${
                        classes.personalityRangeOnePager
                      } ${`${ele?.key}Per`}`}
                      key={i}
                      mt={2}
                    >
                      <Box
                        style={{ color: ele?.color }}
                        className={`${classes.range}`}
                      >
                        <CircularProgressWithLabel {...{ value: ele?.value }} />
                      </Box>
                      <VSNTypography variant="h4" component="h4">
                        <Box>
                          <VSNImage src={ele?.image} alt="yss" />
                        </Box>
                      </VSNTypography>
                      <VSNTypography variant="body1" component="p">
                        {ele.tends_to}
                      </VSNTypography>
                    </Stack>
                  ))}
                </Box>
              </VSNPaper>
            </Box>
          </Stack>
        </Grid>
      </Grid>

      <Box mb={3.5}>
        <Box className={classes.personalitySlider}>
          <VSNTypography
            variant="h5"
            component="h5"
            className={classes.lgHeading}
            mb={1}
          >
            Your Behavioral Blueprint
          </VSNTypography>{" "}
          <Box className={classes.yourPersonalitySliderMain}>
            <VSNSwiper
              className={classes.personalityMain}
              pagination
              navigation
              spaceBetween={20}
              breakpoints={{
                0: {
                  slidesPerView: 1,
                },
                500: {
                  slidesPerView: 2,
                },
                992: {
                  slidesPerView: 2,
                },
                1200: {
                  slidesPerView: 3,
                },
                1400: {
                  slidesPerView: 4,
                },
              }}
              // onActiveIndexChange={onActiveIndexChange}
              // onResize={onActiveIndexChange}
            >
              {onePagerAssessmentResult?.vasana_type_in_brief?.map((obj, i) => (
                <SwiperSlide
                  className={`${classes.personalityBoxMain}  `}
                  key={i}
                >
                  <VSNPaper className={classes.personalityBoxes}>
                    <Box>
                      <VSNTypography variant="h5" component="h5">
                        <VSNImage src={obj?.icon} alt="icon" />
                        {obj?.title}
                      </VSNTypography>
                    </Box>
                    {obj?.summery?.map((item, i) => (
                      <VSNTypography variant="body1" component="p" key={i}>
                        {item}
                      </VSNTypography>
                    ))}
                  </VSNPaper>
                </SwiperSlide>
              ))}
              {onePagerAssessmentResult?.natural_viewpoints?.map((obj, i) => (
                <SwiperSlide
                  key={i}
                  // className={`${classes.personalityBoxMain}  ${
                  //   activeCards?.start ===
                  //     i +
                  //       onePagerAssessmentResult?.vasana_type_in_brief
                  //         ?.length ||
                  //   activeCards?.end ===
                  //     i + onePagerAssessmentResult?.vasana_type_in_brief?.length
                  //     ? classes.activeCard
                  //     : ""
                  // }`}
                >
                  <VSNPaper className={classes.personalityBoxes}>
                    <Box>
                      <VSNTypography variant="h5" component="h5">
                        <VSNImage src={obj?.icon} alt="icon" />
                        {obj?.title}
                      </VSNTypography>
                    </Box>
                    <VSNTypography variant="body1" component="p">
                      {obj.summery}
                    </VSNTypography>
                  </VSNPaper>
                </SwiperSlide>
              ))}
            </VSNSwiper>
          </Box>
        </Box>
      </Box>

      <Box className={classes.diffrentAspectPersonalityMain}>
        <VSNTypography
          variant="h5"
          component="h5"
          className={classes.lgHeading}
          mb={1}
        >
          Your Behavioral Operating Style
        </VSNTypography>
        <VSNPaper className={classes.diffrentPersonalityBox}>
          <VSNImage
            className={classes.diffrentAspectShape1}
            src={Type6}
            alt="Type6"
          />
          <VSNImage
            className={classes.diffrentAspectShape2}
            src={diffrent2}
            alt="diffrent2"
          />
          <VSNImage
            className={classes.diffrentAspectShape3}
            src={Ushape}
            alt="Ushape"
          />
          <Stack
            direction={{ xs: "column", md: "row" }}
            gap={{ xs: 4, md: 1 }}
            justifyContent="space-around"
          >
            {onePagerAssessmentResult?.aspects_of_personality?.map(
              (data, i) => (
                <Box className={classes.positionPersonality} key={i}>
                  <Box
                    className={`${classes.stick} ${
                      (i + 1) % 4 === 0 ? getClass[4] : getClass[(i + 1) % 4]
                    }`}
                  >
                    {/* {data.stick} */}
                  </Box>
                  <Box className={classes.roundShape}>{data.round}</Box>
                  <Box className={classes.imgOut}>
                    <VSNImage src={data.icon} alt="icon" />
                    <VSNTypography variant="body1" component="p">
                      {" "}
                      {data.title}
                    </VSNTypography>
                    <VSNTypography variant="h6" component="h6">
                      {" "}
                      {data.summery}
                    </VSNTypography>
                  </Box>
                </Box>
              )
            )}
          </Stack>
        </VSNPaper>
      </Box>
    </div>
  );
};

export default VasanaOnePagerResult;
